import React, { Fragment } from "react";

import { string, func, bool } from "prop-types";

import { dayOptions, monthOptions, availabilityYearOptions } from "../../../../helpers/index";

import { SelectListGroup } from "../../../../common/index";
import DateError from "../../NamesAndDOB/DateError";

export const availabilityKeys = [
  "availabilityDay",
  "availabilityMonth",
  "availabilityYear",
];

const Availability = ({
  availabilityDay,
  availabilityMonth,
  availabilityYear,
  onChangeHandler,
  isInvalid,
}) => {
  const areAllFieldsFilled =
    availabilityDay && availabilityMonth && availabilityYear;

  const showInvalid = areAllFieldsFilled && isInvalid;

  return (
    <Fragment>
      <div className="form-row align-items-center">
        <div className="col-3 col-md-2">
          <div className="form-group text-lightGrey">
            <SelectListGroup
              value={availabilityDay}
              onChange={(e) => {
                onChangeHandler("availabilityDay", e.target.value);
              }}
              options={dayOptions}
              classes="register_field register_field-dropdown"
              isError={showInvalid}
            />
          </div>
        </div>
        <div className="col-5 col-md-5 col-lg-3">
          <div className="form-group text-lightGrey">
            <SelectListGroup
              value={availabilityMonth}
              onChange={(e) => {
                onChangeHandler("availabilityMonth", e.target.value);
              }}
              options={monthOptions}
              classes="register_field register_field-dropdown"
              isError={showInvalid}
            />
          </div>
        </div>
        <div className="col-3 col-md-3 col-lg-2">
          <div className="form-group text-lightGrey">
            <SelectListGroup
              value={availabilityYear}
              onChange={(e) => {
                onChangeHandler("availabilityYear", e.target.value);
              }}
              options={availabilityYearOptions}
              classes="register_field register_field-dropdown"
              isError={showInvalid}
            />
          </div>
        </div>
        {showInvalid && (
          <DateError
            id="date_error"
            errorMessage={"Availability date needs to be a valid date"}
            isRed={true}
          />
        )}
      </div>
    </Fragment>
  );
};

Availability.propTypes = {
  availabilityDay: string.isRequired,
  availabilityMonth: string.isRequired,
  availabilityYear: string.isRequired,
  onChangeHandler: func.isRequired,
  isInvalid: bool,
};

export default Availability;
